import axiosInstance from "../api/axios";

const ID = "/interior-designers";

/* ---------------- Overview / hero stats ---------------- */
export const getAdminOverview = () => axiosInstance.get(`${ID}/admin/overview`);

/* ---------------- Designers ---------------- */
export const getAllDesigners = () => axiosInstance.get(`${ID}/all`);
export const setDesignerActive = (designerId, isActive) =>
  axiosInstance.patch(`${ID}/${designerId}/active?is_active=${isActive}`);

/* ---------------- Phase applications (subscription requests) ---------------- */
export const getPhaseApplications = (pendingOnly = true) =>
  axiosInstance.get(`${ID}/phase-subscriptions/admin-approvals?pending_only=${pendingOnly}`);
// body: { paymentStatus: "PAID"|"REJECTED", comment?, paymentDate?, paymentMode?, paymentReference? }
export const approvePhaseApplication = (subscriptionId, body) =>
  axiosInstance.post(`${ID}/phase-subscriptions/${subscriptionId}/approval`, body);

/* ---------------- Signed payment receipt ---------------- */
export const generatePaymentReceipt = (subscriptionId) =>
  axiosInstance.post(`${ID}/phase-subscriptions/${subscriptionId}/receipt`);
export const downloadPaymentReceipt = (subscriptionId) =>
  axiosInstance.get(`${ID}/phase-subscriptions/${subscriptionId}/receipt/download`);
